import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { diff } from 'deep-object-diff';

import Button from 'erpcore/components/Button';
import CustomerCreateEditForm from 'erpcore/screens/Customers/components/CustomerCreateEditForm';
import ElementLoader from 'erpcore/components/ElementLoader';
import Modal from 'erpcore/components/Modal';

import { setLocationData } from 'erpcore/components/Form/components/Location/dto';

import { actions as customerActions } from 'erpcore/screens/Customers/Customers.reducer';
import {
    getSingleCustomerFetching,
    getCustomerData
} from 'erpcore/screens/Customers/Customers.selectors';
import { dtoForm } from 'erpcore/utils/dto';

const CustomerEditActionModal = ({ value: iri }) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const customerData = dtoForm(useSelector(state => getCustomerData(state, iri)));
    const fetching = useSelector(getSingleCustomerFetching);
    const params = {
        include: 'city,country,state,accountManager'
    };
    const {
        name,
        email,
        phone,
        website,
        account_manager: accountManager,
        full_address: address,
        street,
        country,
        state,
        city,
        zip,
        latitude,
        longitude
    } = { ...customerData };

    const initialValues = {
        name,
        email,
        phone,
        website,
        account_manager: accountManager,
        location: {
            full_address: address,
            street,
            country,
            state,
            city,
            zip,
            latitude,
            longitude
        }
    };

    const fetchCustomerData = () => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: customerActions.START_FETCHING_CUSTOMER,
                iri,
                promise: { resolve, reject },
                params
            });
        });
    };

    useEffect(() => {
        // fetch data only on modal open
        if (opened) {
            fetchCustomerData();
        }
    }, [opened]);

    const handleModal = () => {
        setOpened(!opened);
    };

    const onSubmit = ({ formData }) => {
        formData = diff(customerData, formData);

        const { location } = { ...formData };

        if (location) {
            formData = setLocationData('location', formData);
        }

        return new Promise((resolve, reject) => {
            dispatch({
                type: customerActions.START_UPDATE_CUSTOMER,
                promise: { resolve, reject },
                iri,
                formData
            });
        })
            .then(() => {
                handleModal();
            })
            .catch(error => {
                return error;
            });
    };

    const modalTitle = () => {
        if (customerData?.name) {
            return `Edit customer - ${customerData.name}`;
        }

        return `Edit company`;
    };

    return (
        <Fragment>
            <Button
                onClick={() => handleModal()}
                variation="action"
                iconName="edit"
                label="Update"
                labelOnlyAria
            />
            <Modal
                variation="medium"
                opened={opened}
                onClose={() => handleModal()}
                title={modalTitle()}
            >
                {fetching === true && <ElementLoader overlay />}
                <CustomerCreateEditForm
                    initialValues={initialValues}
                    form="CustomerEditForm"
                    onSubmit={onSubmit}
                    submitLabel="Update"
                    onCancel={() => handleModal()}
                />
            </Modal>
        </Fragment>
    );
};

CustomerEditActionModal.defaultProps = {
    value: null
};

CustomerEditActionModal.propTypes = {
    value: PropTypes.string
};

export default CustomerEditActionModal;
